<app-legal-document *ngIf="useIframe"></app-legal-document>
<app-cookie-notice-viewer *ngIf="!useIframe"></app-cookie-notice-viewer>